module.exports = __webpack_public_path__ + "static/media/dlwz.c6950051.jpg";